// Neural network overlay — glowing nodes + connecting lines + trailing particles.
// Purely presentational: drop this inside any relatively-positioned host during processing.
export default function NeuralOverlay() {
  const nodes = [
    { x: 15, y: 20 }, { x: 40, y: 12 }, { x: 65, y: 25 }, { x: 85, y: 18 },
    { x: 25, y: 55 }, { x: 55, y: 50 }, { x: 80, y: 60 },
    { x: 18, y: 82 }, { x: 45, y: 88 }, { x: 72, y: 82 }, { x: 92, y: 90 },
  ];
  const edges = [
    [0, 1], [1, 2], [2, 3], [0, 4], [1, 5], [2, 5], [3, 6],
    [4, 5], [5, 6], [4, 7], [5, 8], [5, 9], [6, 9], [6, 10],
    [7, 8], [8, 9], [9, 10],
  ];
  const particles = Array.from({ length: 14 }, (_, i) => ({
    left: `${(i * 37) % 100}%`,
    top: `${(i * 53) % 100}%`,
    delay: `${(i * 0.11).toFixed(2)}s`,
    tx: `${((i * 17) % 60) - 30}px`,
    ty: `${-30 - (i % 4) * 8}px`,
  }));
  return (
    <div
      className="absolute inset-0 pointer-events-none overflow-hidden"
      data-testid="neural-overlay"
      style={{ borderRadius: "inherit" }}
    >
      <svg
        viewBox="0 0 100 100"
        preserveAspectRatio="none"
        className="absolute inset-0 w-full h-full"
      >
        {edges.map(([a, b], i) => (
          <line
            key={i}
            x1={nodes[a].x}
            y1={nodes[a].y}
            x2={nodes[b].x}
            y2={nodes[b].y}
            className="neural-line"
            style={{ animationDelay: `${(i * 0.08).toFixed(2)}s` }}
          />
        ))}
      </svg>
      {nodes.map((n, i) => (
        <span
          key={i}
          className="neural-node"
          style={{
            left: `${n.x}%`,
            top: `${n.y}%`,
            animationDelay: `${(i * 0.09).toFixed(2)}s`,
          }}
        />
      ))}
      {particles.map((p, i) => (
        <span
          key={`p${i}`}
          className="particle-trail"
          style={{
            left: p.left,
            top: p.top,
            animationDelay: p.delay,
            "--tx": p.tx,
            "--ty": p.ty,
          }}
        />
      ))}
    </div>
  );
}
